import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=4f9fcaaf&scoped=true"
import script from "./BaseTextInput.vue?vue&type=script&lang=js"
export * from "./BaseTextInput.vue?vue&type=script&lang=js"
import style0 from "./BaseTextInput.vue?vue&type=style&index=0&id=4f9fcaaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fcaaf",
  null
  
)

export default component.exports